export default __webpack_public_path__ + "static/media/shoppingBasket.33c8e4f3.png";